<template>
  <div>
    <div v-if="!is_login">
      <login @refresh="refresh" />
    </div>
    <el-tabs v-else v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="文件目录" name="file">
        <file />
      </el-tab-pane>
      <el-tab-pane label="上传" name="upload">
        <!-- <demo/> -->
        <upload />
      </el-tab-pane>
      <el-tab-pane label="日志" name="logout">
        <!-- <demo/> -->
        <logout />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// import Demo from './demo.vue';
import File from "./file.vue";
import Login from "./login.vue";
import Upload from "./upload.vue";
import Logout from './logout.vue';
// import Upload from './upload.vue';
export default {
  components: { File, Upload, Login, Logout },
  data() {
    return {
      activeName: "file",
      is_login: false,
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    refresh() {
      this.check_token();
    },
    check_token() {
      if (
        this.$cookies.isKey("token") &&
        this.$cookies.get("token") != "undefined"
      ) {
        console.log("tokentoken");
        console.log(this.$cookies.get("token"));
        var token = this.$cookies.get("token");
        var api = "/check_token/";
        this.axios
          .post(
            api,
            this.$qs.stringify({
              token: token,
            })
          )
          .then((response) => {
            console.log(response.data);
            if (response.data.code == 200) {
              this.$message(response.data.message);
              this.is_login = true;
              this.axios.defaults.headers.common["Authorization"] =
                this.$cookies.get("token");
            } else {
              this.is_login = false;
              this.$message.error(response.data.message);
              this.axios.defaults.headers.common["Authorization"] = "";
              this.$cookies.remove("token");
            }
          });
      } else {
        this.is_login = false;
      }
      console.log(this.is_login);
    },
  },
  mounted() {
    this.check_token();
    this.axios.defaults.baseURL = this.Global.BASE_URL;
    console.log(this.Global.BASE_URL);
    console.log(this.axios.defaults);
  },
};
</script>

<style>
</style>